var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/finance/loans/add')}}},[_vm._v(" New Loan ")])]),_c('a',{staticClass:"heading-title-2"},[_vm._v("Overview")]),_c('div',{staticClass:"card light mn"},[_c('div',{staticClass:"content h-stretch"},[_c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('label',{staticClass:"text-left"},[_vm._v("Loans")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.totalLoans))+" kč")]),_c('label',{staticClass:"text-left"},[_vm._v("Paid Back")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.totalPaid))+" kč")]),_c('label',{staticClass:"text-left"},[_vm._v("Balance")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.balance))+" kč")])])])]),_c('div',{staticClass:"h-stack v-stretch h-space-between gap-3"},[_c('a',{staticClass:"heading-title-2"},[_vm._v("Loans")]),_c('div',{staticClass:"h-stack gap-3"},[_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Created:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.created),expression:"created"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.created)?_vm._i(_vm.created,null)>-1:(_vm.created)},on:{"change":function($event){var $$a=_vm.created,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.created=$$a.concat([$$v]))}else{$$i>-1&&(_vm.created=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.created=$$c}}}}),_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Signed:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signed),expression:"signed"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.signed)?_vm._i(_vm.signed,null)>-1:(_vm.signed)},on:{"change":function($event){var $$a=_vm.signed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.signed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.signed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.signed=$$c}}}}),_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Canceled:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.canceled),expression:"canceled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.canceled)?_vm._i(_vm.canceled,null)>-1:(_vm.canceled)},on:{"change":function($event){var $$a=_vm.canceled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.canceled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.canceled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.canceled=$$c}}}})])]),_c('Table',{attrs:{"items":_vm.filteredLoans,"loading":_vm.loading,"defaultColumn":0,"columns":[
      {
        name: 'User',
        sort: 'alphabet',
        path: ['user', 'fullName'],
      },
      {
        name: 'Date',
        sort: 'date',
        path: ['startDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Amount',
        sort: 'numeric',
        path: ['amount'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Paid',
        sort: 'numeric',
        path: ['paid'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Left To Pay',
        sort: 'numeric',
        path: ['leftToPay'],
        format: 'czk',
        formatType: 'currency',
        styleFunction: (item) => {
          if (item.state == 'signed') {
            if (item.leftToPay > 0) {
              return 'color: red;';
            } else {
              return 'color: green;';
            }
          }
          if (item.state == 'paid') {
            return 'color: green;';
          }
          return '';
        },
      },
      {
        name: 'Monthly',
        sort: 'numeric',
        path: ['monthlyRate'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Description',
        sort: 'alphabet',
        path: ['description'],
      },
      {
        name: 'State',
        sort: 'alphabet',
        path: ['state'],
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/loans/detail/' + $event._id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }